export default __webpack_public_path__ + "static/media/image-mastercard.34fb27c1.svg";